import Cookies from "js-cookie";
import actions from "./actions";
import endpoints from "../api/endpoints";

const {
  doVideoAssociationsRequest,
  doVideoAssociationsSuccess,
  doVideoAssociationsFailure,
} = actions;

const fetchVideoAssociations = (videoId) => async (dispatch) => {
  dispatch(doVideoAssociationsRequest());
  return new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: endpoints.videoAssociations.replace("{{videoId}}", videoId),
      headers: {
        Authorization: "Bearer " + Cookies.get("jwt"),
      },
      success(data, statusText, { status }) {
        dispatch(doVideoAssociationsSuccess({ data, statusText, status }));
        resolve({ data, statusText, status });
      },
      error(xhr) {
        dispatch(doVideoAssociationsFailure(xhr));
        reject(xhr);
      },
    });
  });
};

export default {
  fetchVideoAssociations,
};
